// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =================================
   PAGE
================================= */

.e2e_benchsales_page{

  background:#ffffff;

  padding:22px;

  border-radius:20px;

  border:1px solid #edf2f7;

  box-shadow:
    0 6px 20px rgba(15,23,42,0.05);
}

/* =================================
   TOP SECTION
================================= */

.e2e_benchsales_top{

  display:flex;

  justify-content:space-between;

  align-items:center;

  margin-bottom:24px;

  gap:16px;

  flex-wrap:wrap;
}

.e2e_benchsales_top h2{

  margin:0;

  font-size:24px;

  font-weight:800;

  color:#0f172a;
}

.e2e_benchsales_heading_line{

  width:90px;

  height:4px;

  margin-top:10px;

  border-radius:20px;

  background:
    linear-gradient(
      90deg,
      #2563eb,
      #7c3aed
    );
}

/* =================================
   ADD BUTTON
================================= */

.e2e_benchsales_add_btn{

  border:none;

  height:42px;

  padding:0 22px;

  border-radius:12px;

  font-size:13px;

  font-weight:700;

  color:white;

  cursor:pointer;

  background:
    linear-gradient(
      135deg,
      #1677ff,
      #2563eb
    );

  transition:0.3s ease;
}

.e2e_benchsales_add_btn:hover{

  transform:translateY(-2px);
}

/* =================================
   FILTER SECTION
================================= */

.e2e_benchsales_filters{

  display:flex;

  justify-content:space-between;

  align-items:center;

  gap:20px;

  padding:18px;

  border-radius:16px;

  background:#f8fafc;

  border:1px solid #edf2f7;

  margin-bottom:20px;
}

.e2e_benchsales_filter_left{

  display:flex;

  align-items:center;

  gap:14px;

  flex-wrap:wrap;
}

.e2e_benchsales_filter_left label{

  font-size:14px;

  font-weight:700;

  color:#334155;
}

.e2e_benchsales_select{

  height:40px;

  min-width:200px;

  padding:0 14px;

  border:1px solid #dbe2ea;

  border-radius:12px;

  font-size:13px;

  outline:none;
}

.e2e_benchsales_report_btn{

  border:none;

  height:40px;

  padding:0 18px;

  border-radius:12px;

  background:
    linear-gradient(
      135deg,
      #06b6d4,
      #0891b2
    );

  color:white;

  font-size:13px;

  font-weight:700;

  cursor:pointer;
}

.performence-button{
border:none;
  height:42px;
  padding:0 15px;
  border-radius:12px;

  font-size:13px;

  font-weight:700;

  color:white;

  cursor:pointer;

  background:
    linear-gradient(
      135deg,
      #aa16ff,
      #2563eb
    );

  transition:0.3s ease;
  margin-left: 10px;
}

.performence-button:hover{

  transform:translateY(-3px);
}

.e2e_benchsales_filter_right{

  display:flex;

  align-items:center;
}

.e2e_benchsales_search{

  width:260px;

  height:40px;

  padding:0 14px;

  border:1px solid #dbe2ea;

  border-radius:12px;

  outline:none;
}

/* =================================
   SHOW ENTRIES
================================= */

.e2e_benchsales_show_row{

  margin-bottom:14px;

  font-size:14px;

  color:#475569;
}

.e2e_benchsales_entries{

  height:36px;

  margin:0 8px;

  padding:0 10px;

  border:1px solid #dbe2ea;

  border-radius:8px;
}

/* =================================
   TABLE WRAPPER
================================= */

.e2e_benchsales_table_wrapper{

  overflow-x:auto;
}

/* =================================
   TABLE
================================= */

.e2e_benchsales_table{

  width:100%;

  border-collapse:separate;

  border-spacing:0 10px;

  table-layout:fixed;
}

/* =================================
   HEADERS
================================= */

.e2e_benchsales_head_row{

  background:#f8fafc;
}

.e2e_benchsales_head_row th{

  padding:15px;

  font-size:12px;

  font-weight:800;

  text-transform:uppercase;

  color:#475569;

  border-top:1px solid #e2e8f0;

  border-bottom:1px solid #e2e8f0;

  text-align:center;
}

/* =================================
   BODY ROWS
================================= */

.e2e_benchsales_row{

  background:white;

  transition:0.3s ease;

  box-shadow:
    0 3px 12px rgba(15,23,42,0.04);
}

.e2e_benchsales_row:hover{

  transform:translateY(-2px);

  box-shadow:
    0 10px 24px rgba(15,23,42,0.08);
}

.e2e_benchsales_row_placed{
  background:linear-gradient(90deg, #f0fdf4 0%, #ffffff 42%);
  box-shadow:0 4px 16px rgba(22,163,74,0.12);
}

.e2e_benchsales_row_placed td{
  border-top-color:#bbf7d0;
  border-bottom-color:#bbf7d0;
}

.e2e_benchsales_row_placed td:first-child{
  border-left:4px solid #22c55e;
}

/* =================================
   TABLE DATA
================================= */

.e2e_benchsales_row td{

  padding:18px 16px;

  border-top:1px solid #f1f5f9;

  border-bottom:1px solid #f1f5f9;

  font-size:13px;

  font-weight:600;

  color:#0f172a;

  text-align:center;

  vertical-align:middle;
}

/* =================================
   COLUMN WIDTHS
================================= */

.e2e_benchsales_th_id,
.e2e_benchsales_td_id{

  width:50px;
}

.e2e_benchsales_th_consultant,
.e2e_benchsales_td_consultant{

  width:30%;

  text-align:left;
}

.e2e_benchsales_th_technology,
.e2e_benchsales_td_technology{

  width:20%;
}

.e2e_benchsales_th_recruiter,
.e2e_benchsales_td_recruiter{

  width:15%;
}

.e2e_benchsales_th_location,
.e2e_benchsales_td_location{

  width:20%;
}

.e2e_benchsales_th_action,
.e2e_benchsales_td_action{

  width:220px;
}

/* =================================
   RADIUS
================================= */

.e2e_benchsales_row td:first-child{

  border-left:1px solid #f1f5f9;

  border-top-left-radius:14px;

  border-bottom-left-radius:14px;

  color:#2563eb;

  font-weight:800;
}

.e2e_benchsales_row td:last-child{

  border-right:1px solid #f1f5f9;

  border-top-right-radius:14px;

  border-bottom-right-radius:14px;
}

/* =================================
   DETAILS
================================= */

.e2e_benchsales_details{

  display:flex;

  flex-direction:column;
  align-items: flex-start;

  gap:8px;
}

.e2e_benchsales_details p{

  margin:0;

  font-size:13px;

  line-height:1.5;

  color:#475569;
  text-align: left;
}

.e2e_benchsales_details strong{

  color:#0f172a;

  margin-left:5px;
}

/* =================================
   ACTIONS
================================= */

.e2e_benchsales_actions{

  display:flex;

  align-items:center;

  justify-content:center;

  gap:8px;

  flex-wrap:nowrap;
}

/* =================================
   BUTTONS
================================= */

.e2e_benchsales_view_btn,
.e2e_benchsales_edit_btn,
.e2e_benchsales_delete_btn{

  border:none;

  min-width:64px;

  height:32px;

  border-radius:10px;

  font-size:11px;

  font-weight:700;

  cursor:pointer;

  transition:0.3s ease;
}

.e2e_benchsales_view_btn{

  background:#dbeafe;

  color:#2563eb;
}

.e2e_benchsales_view_btn:hover{

  background:#2563eb;

  color:white;
}

.e2e_benchsales_edit_btn{

  background:#fef3c7;

  color:#d97706;
}

.e2e_benchsales_edit_btn:hover{

  background:#f59e0b;

  color:white;
}

.e2e_benchsales_delete_btn{

  background:#fee2e2;

  color:#dc2626;
}

.e2e_benchsales_delete_btn:hover{

  background:#dc2626;

  color:white;
}

/* =================================
   RESPONSIVE
================================= */

@media(max-width:992px){

  .e2e_benchsales_filters{

    flex-direction:column;

    align-items:stretch;
  }

  .e2e_benchsales_search{

    width:100%;
  }

  .e2e_benchsales_table{

    min-width:1100px;
  }

}
.e2e_benchsales_th_submission,
.e2e_benchsales_td_submission{
  width:16%;
}

.e2e_benchsales_th_candidate,
.e2e_benchsales_td_candidate{
  width:34%;
  text-align:left;
}

.e2e_benchsales_th_poc,
.e2e_benchsales_td_poc{
  width: 30%;
  text-align: center;
  white-space: wrap;
  text-wrap: wrap;
  margin-right: 10px;
  /* overflow: hidden; */
  /* text-overflow: ellipsis; */
}

.e2e_benchsales_th_client,
.e2e_benchsales_td_client{
  width:18%;
}

@media(max-width:768px){
  .e2e_recruiting_page{
    padding:14px;
    border-radius:16px;
  }

  .e2e_recruiting_left h2{
    display:flex;
    flex-direction:column;
    align-items:flex-start;
    gap:10px;
    font-size:20px;
  }

  .performence-button{
    width:100%;
    min-height:42px;
    margin-left:0;
  }

  .e2e_benchsales_table_wrapper{
    margin:0 -14px;
    padding:0 14px 8px;
  }

  .e2e_benchsales_row:hover{
    transform:none;
  }

  .e2e_benchsales_row td{
    padding:14px 10px;
  }

  .e2e_benchsales_actions{
    gap:6px;
  }

  .e2e_benchsales_view_btn,
  .e2e_benchsales_edit_btn,
  .e2e_benchsales_delete_btn{
    min-width:58px;
    min-height:38px;
  }
}

.e2e_benchsales_th_process,
.e2e_benchsales_td_process{
  width:18%;
}

.e2e_benchsales_td_process{
  white-space:nowrap;
}

.e2e_benchsales_process_badge{
  display:inline-flex;
  align-items:center;
  justify-content:center;
  gap:6px;
  min-height:30px;
  padding:5px 11px;
  border:1px solid transparent;
  border-radius:999px;
  font-size:11px;
  font-weight:800;
  line-height:1.2;
}

.e2e_benchsales_process_submitted{
  color:#1d4ed8;
  background:#eff6ff;
  border-color:#bfdbfe;
}

.e2e_benchsales_process_interview{
  color:#a16207;
  background:#fefce8;
  border-color:#fde68a;
}

.e2e_benchsales_process_placed{
  color:#15803d;
  background:#dcfce7;
  border-color:#86efac;
  box-shadow:0 2px 8px rgba(22,163,74,0.14);
}

.e2e_benchsales_process_unknown{
  color:#64748b;
  background:#f1f5f9;
  border-color:#e2e8f0;
}

.e2e_benchsales_placed_note{
  display:block;
  margin-top:5px;
  color:#15803d;
  font-size:10px;
  font-weight:700;
}

.e2e_benchsales_th_action,
.e2e_benchsales_td_action{
  width:220px;
}

.e2e_benchsales_record_link{border:0;padding:0;background:transparent;color:#4f46e5;font:inherit;font-weight:700;text-align:left;cursor:pointer}
.e2e_benchsales_record_link:hover{text-decoration:underline;color:#3730a3}
/* Professional Process column alignment */
.e2e_benchsales_th_process,.e2e_benchsales_td_process{width:170px;min-width:170px;box-sizing:border-box;text-align:center!important}
.e2e_benchsales_process_content{display:flex;width:100%;min-height:52px;align-items:center;justify-content:center;flex-direction:column;gap:5px}
.e2e_benchsales_process_badge{width:142px;min-height:32px;box-sizing:border-box;padding:6px 10px;white-space:nowrap}
.e2e_benchsales_process_note{display:block;height:12px;margin:0;color:transparent;font-size:9px;font-weight:750;line-height:12px;white-space:nowrap;visibility:hidden}
.e2e_benchsales_process_note.visible{color:#15803d;visibility:visible}
.e2e_benchsales_placed_note{display:none}
@media(max-width:768px){.e2e_benchsales_th_process,.e2e_benchsales_td_process{width:160px;min-width:160px}.e2e_benchsales_process_badge{width:134px}}`, "",{"version":3,"sources":["webpack://./src/styles/Dashboard/benchsales.css"],"names":[],"mappings":"AAAA;;mCAEmC;;AAEnC;;EAEE,kBAAkB;;EAElB,YAAY;;EAEZ,kBAAkB;;EAElB,wBAAwB;;EAExB;kCACgC;AAClC;;AAEA;;mCAEmC;;AAEnC;;EAEE,YAAY;;EAEZ,6BAA6B;;EAE7B,kBAAkB;;EAElB,kBAAkB;;EAElB,QAAQ;;EAER,cAAc;AAChB;;AAEA;;EAEE,QAAQ;;EAER,cAAc;;EAEd,eAAe;;EAEf,aAAa;AACf;;AAEA;;EAEE,UAAU;;EAEV,UAAU;;EAEV,eAAe;;EAEf,kBAAkB;;EAElB;;;;;KAKG;AACL;;AAEA;;mCAEmC;;AAEnC;;EAEE,WAAW;;EAEX,WAAW;;EAEX,cAAc;;EAEd,kBAAkB;;EAElB,cAAc;;EAEd,eAAe;;EAEf,WAAW;;EAEX,cAAc;;EAEd;;;;;KAKG;;EAEH,oBAAoB;AACtB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;mCAEmC;;AAEnC;;EAEE,YAAY;;EAEZ,6BAA6B;;EAE7B,kBAAkB;;EAElB,QAAQ;;EAER,YAAY;;EAEZ,kBAAkB;;EAElB,kBAAkB;;EAElB,wBAAwB;;EAExB,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;;EAEZ,kBAAkB;;EAElB,QAAQ;;EAER,cAAc;AAChB;;AAEA;;EAEE,cAAc;;EAEd,eAAe;;EAEf,aAAa;AACf;;AAEA;;EAEE,WAAW;;EAEX,eAAe;;EAEf,cAAc;;EAEd,wBAAwB;;EAExB,kBAAkB;;EAElB,cAAc;;EAEd,YAAY;AACd;;AAEA;;EAEE,WAAW;;EAEX,WAAW;;EAEX,cAAc;;EAEd,kBAAkB;;EAElB;;;;;KAKG;;EAEH,WAAW;;EAEX,cAAc;;EAEd,eAAe;;EAEf,cAAc;AAChB;;AAEA;AACA,WAAW;EACT,WAAW;EACX,cAAc;EACd,kBAAkB;;EAElB,cAAc;;EAEd,eAAe;;EAEf,WAAW;;EAEX,cAAc;;EAEd;;;;;KAKG;;EAEH,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,YAAY;;EAEZ,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;;EAEX,WAAW;;EAEX,cAAc;;EAEd,wBAAwB;;EAExB,kBAAkB;;EAElB,YAAY;AACd;;AAEA;;mCAEmC;;AAEnC;;EAEE,kBAAkB;;EAElB,cAAc;;EAEd,aAAa;AACf;;AAEA;;EAEE,WAAW;;EAEX,YAAY;;EAEZ,cAAc;;EAEd,wBAAwB;;EAExB,iBAAiB;AACnB;;AAEA;;mCAEmC;;AAEnC;;EAEE,eAAe;AACjB;;AAEA;;mCAEmC;;AAEnC;;EAEE,UAAU;;EAEV,wBAAwB;;EAExB,qBAAqB;;EAErB,kBAAkB;AACpB;;AAEA;;mCAEmC;;AAEnC;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;;EAEZ,cAAc;;EAEd,eAAe;;EAEf,wBAAwB;;EAExB,aAAa;;EAEb,4BAA4B;;EAE5B,+BAA+B;;EAE/B,iBAAiB;AACnB;;AAEA;;mCAEmC;;AAEnC;;EAEE,gBAAgB;;EAEhB,oBAAoB;;EAEpB;kCACgC;AAClC;;AAEA;;EAEE,0BAA0B;;EAE1B;mCACiC;AACnC;;AAEA;EACE,0DAA0D;EAC1D,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;mCAEmC;;AAEnC;;EAEE,iBAAiB;;EAEjB,4BAA4B;;EAE5B,+BAA+B;;EAE/B,cAAc;;EAEd,eAAe;;EAEf,aAAa;;EAEb,iBAAiB;;EAEjB,qBAAqB;AACvB;;AAEA;;mCAEmC;;AAEnC;;;EAGE,UAAU;AACZ;;AAEA;;;EAGE,SAAS;;EAET,eAAe;AACjB;;AAEA;;;EAGE,SAAS;AACX;;AAEA;;;EAGE,SAAS;AACX;;AAEA;;;EAGE,SAAS;AACX;;AAEA;;;EAGE,WAAW;AACb;;AAEA;;mCAEmC;;AAEnC;;EAEE,6BAA6B;;EAE7B,2BAA2B;;EAE3B,8BAA8B;;EAE9B,aAAa;;EAEb,eAAe;AACjB;;AAEA;;EAEE,8BAA8B;;EAE9B,4BAA4B;;EAE5B,+BAA+B;AACjC;;AAEA;;mCAEmC;;AAEnC;;EAEE,YAAY;;EAEZ,qBAAqB;EACrB,uBAAuB;;EAEvB,OAAO;AACT;;AAEA;;EAEE,QAAQ;;EAER,cAAc;;EAEd,eAAe;;EAEf,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;;EAEb,eAAe;AACjB;;AAEA;;mCAEmC;;AAEnC;;EAEE,YAAY;;EAEZ,kBAAkB;;EAElB,sBAAsB;;EAEtB,OAAO;;EAEP,gBAAgB;AAClB;;AAEA;;mCAEmC;;AAEnC;;;;EAIE,WAAW;;EAEX,cAAc;;EAEd,WAAW;;EAEX,kBAAkB;;EAElB,cAAc;;EAEd,eAAe;;EAEf,cAAc;;EAEd,oBAAoB;AACtB;;AAEA;;EAEE,kBAAkB;;EAElB,aAAa;AACf;;AAEA;;EAEE,kBAAkB;;EAElB,WAAW;AACb;;AAEA;;EAEE,kBAAkB;;EAElB,aAAa;AACf;;AAEA;;EAEE,kBAAkB;;EAElB,WAAW;AACb;;AAEA;;EAEE,kBAAkB;;EAElB,aAAa;AACf;;AAEA;;EAEE,kBAAkB;;EAElB,WAAW;AACb;;AAEA;;mCAEmC;;AAEnC;;EAEE;;IAEE,qBAAqB;;IAErB,mBAAmB;EACrB;;EAEA;;IAEE,UAAU;EACZ;;EAEA;;IAEE,gBAAgB;EAClB;;AAEF;AACA;;EAEE,SAAS;AACX;;AAEA;;EAEE,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;IACtB,QAAQ;IACR,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,eAAe;IACf,aAAa;EACf;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,OAAO;EACT;;EAEA;;;IAGE,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,OAAO;EACP,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,WAAW;AACb;;AAEA,4BAA4B,QAAQ,CAAC,SAAS,CAAC,sBAAsB,CAAC,aAAa,CAAC,YAAY,CAAC,eAAe,CAAC,eAAe,CAAC,cAAc;AAC/I,kCAAkC,yBAAyB,CAAC,aAAa;AACzE,0CAA0C;AAC1C,sDAAsD,WAAW,CAAC,eAAe,CAAC,qBAAqB,CAAC,2BAA2B;AACnI,gCAAgC,YAAY,CAAC,UAAU,CAAC,eAAe,CAAC,kBAAkB,CAAC,sBAAsB,CAAC,qBAAqB,CAAC,OAAO;AAC/I,8BAA8B,WAAW,CAAC,eAAe,CAAC,qBAAqB,CAAC,gBAAgB,CAAC,kBAAkB;AACnH,6BAA6B,aAAa,CAAC,WAAW,CAAC,QAAQ,CAAC,iBAAiB,CAAC,aAAa,CAAC,eAAe,CAAC,gBAAgB,CAAC,kBAAkB,CAAC,iBAAiB;AACrK,qCAAqC,aAAa,CAAC,kBAAkB;AACrE,4BAA4B,YAAY;AACxC,wBAAwB,sDAAsD,WAAW,CAAC,eAAe,CAAC,8BAA8B,WAAW,CAAC","sourcesContent":["/* =================================\r\n   PAGE\r\n================================= */\r\n\r\n.e2e_benchsales_page{\r\n\r\n  background:#ffffff;\r\n\r\n  padding:22px;\r\n\r\n  border-radius:20px;\r\n\r\n  border:1px solid #edf2f7;\r\n\r\n  box-shadow:\r\n    0 6px 20px rgba(15,23,42,0.05);\r\n}\r\n\r\n/* =================================\r\n   TOP SECTION\r\n================================= */\r\n\r\n.e2e_benchsales_top{\r\n\r\n  display:flex;\r\n\r\n  justify-content:space-between;\r\n\r\n  align-items:center;\r\n\r\n  margin-bottom:24px;\r\n\r\n  gap:16px;\r\n\r\n  flex-wrap:wrap;\r\n}\r\n\r\n.e2e_benchsales_top h2{\r\n\r\n  margin:0;\r\n\r\n  font-size:24px;\r\n\r\n  font-weight:800;\r\n\r\n  color:#0f172a;\r\n}\r\n\r\n.e2e_benchsales_heading_line{\r\n\r\n  width:90px;\r\n\r\n  height:4px;\r\n\r\n  margin-top:10px;\r\n\r\n  border-radius:20px;\r\n\r\n  background:\r\n    linear-gradient(\r\n      90deg,\r\n      #2563eb,\r\n      #7c3aed\r\n    );\r\n}\r\n\r\n/* =================================\r\n   ADD BUTTON\r\n================================= */\r\n\r\n.e2e_benchsales_add_btn{\r\n\r\n  border:none;\r\n\r\n  height:42px;\r\n\r\n  padding:0 22px;\r\n\r\n  border-radius:12px;\r\n\r\n  font-size:13px;\r\n\r\n  font-weight:700;\r\n\r\n  color:white;\r\n\r\n  cursor:pointer;\r\n\r\n  background:\r\n    linear-gradient(\r\n      135deg,\r\n      #1677ff,\r\n      #2563eb\r\n    );\r\n\r\n  transition:0.3s ease;\r\n}\r\n\r\n.e2e_benchsales_add_btn:hover{\r\n\r\n  transform:translateY(-2px);\r\n}\r\n\r\n/* =================================\r\n   FILTER SECTION\r\n================================= */\r\n\r\n.e2e_benchsales_filters{\r\n\r\n  display:flex;\r\n\r\n  justify-content:space-between;\r\n\r\n  align-items:center;\r\n\r\n  gap:20px;\r\n\r\n  padding:18px;\r\n\r\n  border-radius:16px;\r\n\r\n  background:#f8fafc;\r\n\r\n  border:1px solid #edf2f7;\r\n\r\n  margin-bottom:20px;\r\n}\r\n\r\n.e2e_benchsales_filter_left{\r\n\r\n  display:flex;\r\n\r\n  align-items:center;\r\n\r\n  gap:14px;\r\n\r\n  flex-wrap:wrap;\r\n}\r\n\r\n.e2e_benchsales_filter_left label{\r\n\r\n  font-size:14px;\r\n\r\n  font-weight:700;\r\n\r\n  color:#334155;\r\n}\r\n\r\n.e2e_benchsales_select{\r\n\r\n  height:40px;\r\n\r\n  min-width:200px;\r\n\r\n  padding:0 14px;\r\n\r\n  border:1px solid #dbe2ea;\r\n\r\n  border-radius:12px;\r\n\r\n  font-size:13px;\r\n\r\n  outline:none;\r\n}\r\n\r\n.e2e_benchsales_report_btn{\r\n\r\n  border:none;\r\n\r\n  height:40px;\r\n\r\n  padding:0 18px;\r\n\r\n  border-radius:12px;\r\n\r\n  background:\r\n    linear-gradient(\r\n      135deg,\r\n      #06b6d4,\r\n      #0891b2\r\n    );\r\n\r\n  color:white;\r\n\r\n  font-size:13px;\r\n\r\n  font-weight:700;\r\n\r\n  cursor:pointer;\r\n}\r\n\r\n.performence-button{\r\nborder:none;\r\n  height:42px;\r\n  padding:0 15px;\r\n  border-radius:12px;\r\n\r\n  font-size:13px;\r\n\r\n  font-weight:700;\r\n\r\n  color:white;\r\n\r\n  cursor:pointer;\r\n\r\n  background:\r\n    linear-gradient(\r\n      135deg,\r\n      #aa16ff,\r\n      #2563eb\r\n    );\r\n\r\n  transition:0.3s ease;\r\n  margin-left: 10px;\r\n}\r\n\r\n.performence-button:hover{\r\n\r\n  transform:translateY(-3px);\r\n}\r\n\r\n.e2e_benchsales_filter_right{\r\n\r\n  display:flex;\r\n\r\n  align-items:center;\r\n}\r\n\r\n.e2e_benchsales_search{\r\n\r\n  width:260px;\r\n\r\n  height:40px;\r\n\r\n  padding:0 14px;\r\n\r\n  border:1px solid #dbe2ea;\r\n\r\n  border-radius:12px;\r\n\r\n  outline:none;\r\n}\r\n\r\n/* =================================\r\n   SHOW ENTRIES\r\n================================= */\r\n\r\n.e2e_benchsales_show_row{\r\n\r\n  margin-bottom:14px;\r\n\r\n  font-size:14px;\r\n\r\n  color:#475569;\r\n}\r\n\r\n.e2e_benchsales_entries{\r\n\r\n  height:36px;\r\n\r\n  margin:0 8px;\r\n\r\n  padding:0 10px;\r\n\r\n  border:1px solid #dbe2ea;\r\n\r\n  border-radius:8px;\r\n}\r\n\r\n/* =================================\r\n   TABLE WRAPPER\r\n================================= */\r\n\r\n.e2e_benchsales_table_wrapper{\r\n\r\n  overflow-x:auto;\r\n}\r\n\r\n/* =================================\r\n   TABLE\r\n================================= */\r\n\r\n.e2e_benchsales_table{\r\n\r\n  width:100%;\r\n\r\n  border-collapse:separate;\r\n\r\n  border-spacing:0 10px;\r\n\r\n  table-layout:fixed;\r\n}\r\n\r\n/* =================================\r\n   HEADERS\r\n================================= */\r\n\r\n.e2e_benchsales_head_row{\r\n\r\n  background:#f8fafc;\r\n}\r\n\r\n.e2e_benchsales_head_row th{\r\n\r\n  padding:15px;\r\n\r\n  font-size:12px;\r\n\r\n  font-weight:800;\r\n\r\n  text-transform:uppercase;\r\n\r\n  color:#475569;\r\n\r\n  border-top:1px solid #e2e8f0;\r\n\r\n  border-bottom:1px solid #e2e8f0;\r\n\r\n  text-align:center;\r\n}\r\n\r\n/* =================================\r\n   BODY ROWS\r\n================================= */\r\n\r\n.e2e_benchsales_row{\r\n\r\n  background:white;\r\n\r\n  transition:0.3s ease;\r\n\r\n  box-shadow:\r\n    0 3px 12px rgba(15,23,42,0.04);\r\n}\r\n\r\n.e2e_benchsales_row:hover{\n\r\n  transform:translateY(-2px);\r\n\r\n  box-shadow:\n    0 10px 24px rgba(15,23,42,0.08);\n}\n\n.e2e_benchsales_row_placed{\n  background:linear-gradient(90deg, #f0fdf4 0%, #ffffff 42%);\n  box-shadow:0 4px 16px rgba(22,163,74,0.12);\n}\n\n.e2e_benchsales_row_placed td{\n  border-top-color:#bbf7d0;\n  border-bottom-color:#bbf7d0;\n}\n\n.e2e_benchsales_row_placed td:first-child{\n  border-left:4px solid #22c55e;\n}\n\r\n/* =================================\r\n   TABLE DATA\r\n================================= */\r\n\r\n.e2e_benchsales_row td{\r\n\r\n  padding:18px 16px;\r\n\r\n  border-top:1px solid #f1f5f9;\r\n\r\n  border-bottom:1px solid #f1f5f9;\r\n\r\n  font-size:13px;\r\n\r\n  font-weight:600;\r\n\r\n  color:#0f172a;\r\n\r\n  text-align:center;\r\n\r\n  vertical-align:middle;\r\n}\r\n\r\n/* =================================\r\n   COLUMN WIDTHS\r\n================================= */\r\n\r\n.e2e_benchsales_th_id,\r\n.e2e_benchsales_td_id{\r\n\r\n  width:50px;\r\n}\r\n\r\n.e2e_benchsales_th_consultant,\r\n.e2e_benchsales_td_consultant{\r\n\r\n  width:30%;\r\n\r\n  text-align:left;\r\n}\r\n\r\n.e2e_benchsales_th_technology,\r\n.e2e_benchsales_td_technology{\r\n\r\n  width:20%;\r\n}\r\n\r\n.e2e_benchsales_th_recruiter,\r\n.e2e_benchsales_td_recruiter{\r\n\r\n  width:15%;\r\n}\r\n\r\n.e2e_benchsales_th_location,\r\n.e2e_benchsales_td_location{\r\n\r\n  width:20%;\r\n}\r\n\r\n.e2e_benchsales_th_action,\r\n.e2e_benchsales_td_action{\r\n\r\n  width:220px;\r\n}\r\n\r\n/* =================================\r\n   RADIUS\r\n================================= */\r\n\r\n.e2e_benchsales_row td:first-child{\r\n\r\n  border-left:1px solid #f1f5f9;\r\n\r\n  border-top-left-radius:14px;\r\n\r\n  border-bottom-left-radius:14px;\r\n\r\n  color:#2563eb;\r\n\r\n  font-weight:800;\r\n}\r\n\r\n.e2e_benchsales_row td:last-child{\r\n\r\n  border-right:1px solid #f1f5f9;\r\n\r\n  border-top-right-radius:14px;\r\n\r\n  border-bottom-right-radius:14px;\r\n}\r\n\r\n/* =================================\r\n   DETAILS\r\n================================= */\r\n\r\n.e2e_benchsales_details{\r\n\r\n  display:flex;\r\n\r\n  flex-direction:column;\r\n  align-items: flex-start;\r\n\r\n  gap:8px;\r\n}\r\n\r\n.e2e_benchsales_details p{\r\n\r\n  margin:0;\r\n\r\n  font-size:13px;\r\n\r\n  line-height:1.5;\r\n\r\n  color:#475569;\r\n  text-align: left;\r\n}\r\n\r\n.e2e_benchsales_details strong{\r\n\r\n  color:#0f172a;\r\n\r\n  margin-left:5px;\r\n}\r\n\r\n/* =================================\r\n   ACTIONS\r\n================================= */\r\n\r\n.e2e_benchsales_actions{\r\n\r\n  display:flex;\r\n\r\n  align-items:center;\r\n\r\n  justify-content:center;\r\n\r\n  gap:8px;\r\n\r\n  flex-wrap:nowrap;\r\n}\r\n\r\n/* =================================\r\n   BUTTONS\r\n================================= */\r\n\r\n.e2e_benchsales_view_btn,\r\n.e2e_benchsales_edit_btn,\r\n.e2e_benchsales_delete_btn{\r\n\r\n  border:none;\r\n\r\n  min-width:64px;\r\n\r\n  height:32px;\r\n\r\n  border-radius:10px;\r\n\r\n  font-size:11px;\r\n\r\n  font-weight:700;\r\n\r\n  cursor:pointer;\r\n\r\n  transition:0.3s ease;\r\n}\r\n\r\n.e2e_benchsales_view_btn{\r\n\r\n  background:#dbeafe;\r\n\r\n  color:#2563eb;\r\n}\r\n\r\n.e2e_benchsales_view_btn:hover{\r\n\r\n  background:#2563eb;\r\n\r\n  color:white;\r\n}\r\n\r\n.e2e_benchsales_edit_btn{\r\n\r\n  background:#fef3c7;\r\n\r\n  color:#d97706;\r\n}\r\n\r\n.e2e_benchsales_edit_btn:hover{\r\n\r\n  background:#f59e0b;\r\n\r\n  color:white;\r\n}\r\n\r\n.e2e_benchsales_delete_btn{\r\n\r\n  background:#fee2e2;\r\n\r\n  color:#dc2626;\r\n}\r\n\r\n.e2e_benchsales_delete_btn:hover{\r\n\r\n  background:#dc2626;\r\n\r\n  color:white;\r\n}\r\n\r\n/* =================================\r\n   RESPONSIVE\r\n================================= */\r\n\r\n@media(max-width:992px){\n\r\n  .e2e_benchsales_filters{\r\n\r\n    flex-direction:column;\r\n\r\n    align-items:stretch;\r\n  }\r\n\r\n  .e2e_benchsales_search{\r\n\r\n    width:100%;\r\n  }\r\n\r\n  .e2e_benchsales_table{\r\n\r\n    min-width:1100px;\r\n  }\r\n\r\n}\r\n.e2e_benchsales_th_submission,\r\n.e2e_benchsales_td_submission{\r\n  width:16%;\r\n}\r\n\r\n.e2e_benchsales_th_candidate,\r\n.e2e_benchsales_td_candidate{\r\n  width:34%;\r\n  text-align:left;\r\n}\r\n\r\n.e2e_benchsales_th_poc,\r\n.e2e_benchsales_td_poc{\r\n  width: 30%;\r\n  text-align: center;\r\n  white-space: wrap;\r\n  text-wrap: wrap;\r\n  margin-right: 10px;\r\n  /* overflow: hidden; */\r\n  /* text-overflow: ellipsis; */\r\n}\r\n\r\n.e2e_benchsales_th_client,\n.e2e_benchsales_td_client{\n  width:18%;\n}\n\n@media(max-width:768px){\n  .e2e_recruiting_page{\n    padding:14px;\n    border-radius:16px;\n  }\n\n  .e2e_recruiting_left h2{\n    display:flex;\n    flex-direction:column;\n    align-items:flex-start;\n    gap:10px;\n    font-size:20px;\n  }\n\n  .performence-button{\n    width:100%;\n    min-height:42px;\n    margin-left:0;\n  }\n\n  .e2e_benchsales_table_wrapper{\n    margin:0 -14px;\n    padding:0 14px 8px;\n  }\n\n  .e2e_benchsales_row:hover{\n    transform:none;\n  }\n\n  .e2e_benchsales_row td{\n    padding:14px 10px;\n  }\n\n  .e2e_benchsales_actions{\n    gap:6px;\n  }\n\n  .e2e_benchsales_view_btn,\n  .e2e_benchsales_edit_btn,\n  .e2e_benchsales_delete_btn{\n    min-width:58px;\n    min-height:38px;\n  }\n}\n\n.e2e_benchsales_th_process,\n.e2e_benchsales_td_process{\n  width:18%;\n}\n\n.e2e_benchsales_td_process{\n  white-space:nowrap;\n}\n\n.e2e_benchsales_process_badge{\n  display:inline-flex;\n  align-items:center;\n  justify-content:center;\n  gap:6px;\n  min-height:30px;\n  padding:5px 11px;\n  border:1px solid transparent;\n  border-radius:999px;\n  font-size:11px;\n  font-weight:800;\n  line-height:1.2;\n}\n\n.e2e_benchsales_process_submitted{\n  color:#1d4ed8;\n  background:#eff6ff;\n  border-color:#bfdbfe;\n}\n\n.e2e_benchsales_process_interview{\n  color:#a16207;\n  background:#fefce8;\n  border-color:#fde68a;\n}\n\n.e2e_benchsales_process_placed{\n  color:#15803d;\n  background:#dcfce7;\n  border-color:#86efac;\n  box-shadow:0 2px 8px rgba(22,163,74,0.14);\n}\n\n.e2e_benchsales_process_unknown{\n  color:#64748b;\n  background:#f1f5f9;\n  border-color:#e2e8f0;\n}\n\n.e2e_benchsales_placed_note{\n  display:block;\n  margin-top:5px;\n  color:#15803d;\n  font-size:10px;\n  font-weight:700;\n}\n\r\n.e2e_benchsales_th_action,\r\n.e2e_benchsales_td_action{\r\n  width:220px;\r\n}\n\n.e2e_benchsales_record_link{border:0;padding:0;background:transparent;color:#4f46e5;font:inherit;font-weight:700;text-align:left;cursor:pointer}\n.e2e_benchsales_record_link:hover{text-decoration:underline;color:#3730a3}\n/* Professional Process column alignment */\n.e2e_benchsales_th_process,.e2e_benchsales_td_process{width:170px;min-width:170px;box-sizing:border-box;text-align:center!important}\n.e2e_benchsales_process_content{display:flex;width:100%;min-height:52px;align-items:center;justify-content:center;flex-direction:column;gap:5px}\n.e2e_benchsales_process_badge{width:142px;min-height:32px;box-sizing:border-box;padding:6px 10px;white-space:nowrap}\n.e2e_benchsales_process_note{display:block;height:12px;margin:0;color:transparent;font-size:9px;font-weight:750;line-height:12px;white-space:nowrap;visibility:hidden}\n.e2e_benchsales_process_note.visible{color:#15803d;visibility:visible}\n.e2e_benchsales_placed_note{display:none}\n@media(max-width:768px){.e2e_benchsales_th_process,.e2e_benchsales_td_process{width:160px;min-width:160px}.e2e_benchsales_process_badge{width:134px}}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
